import React, { useState, useEffect, useRef } from "react";
import style from "../../Assets/css/b2bTraining.module.css";
import check from "../../Assets/img/Group 7810.png";

const B2BTraining = () => {
	const [checkBoxes, setCheckBoxes] = useState([]);
	const [checkboxCount, setCheckboxCount] = useState(0);
	const input_val = useRef(null);
	const API_ENDPOINT = `https://api.catileverlabs.com/`;

	const training_sessions = {
		resume_writing: "Art & Science of RESUME WRITING",
		impress_interviews: "Express to Impress Interviews",
		group_discussion: "Grab the Spotlight GROUP DISCUSSION",
		harvard_intern: "How to intern at Harvard, Stanford, MIT",
		cpp_timeComplexity: "C/C++ & Time Complexity",
		java_pythonCore: "Java, Python Core & Advanced",
		dataStructures_algo: "Data Structures & Algorithms",
		github_openSource: "GIT HUB, G SOC, Open Source Contribution",
		quantitative_ability: "Quantitative Ability",
		logical_reasoning: "Logical Reasoning",
		verbal_ability: "Verbal Ability",
		recruiters_linkedin: "How to Impress Recruiters on LinkedIn",
	};

	async function checkedBoxes() {
		let checkboxes;
		checkboxes = document.querySelectorAll(
			".checkbox-options > div > input:checked"
		);
		let uncheckboxes = document.querySelectorAll(
			`.checkbox-options > div > input[type="checkbox"]:not(:checked)`
		);
		if (checkboxes.length === 3) {
			uncheckboxes.forEach((checkbox) => {
				checkbox.setAttribute("disabled", "");
			});
		}
		if (checkboxes.length <= 2) {
			uncheckboxes.forEach((checkbox) => {
				checkbox.removeAttribute("disabled");
			});
		}
		await setCheckboxCount(checkboxes.length);
		let checked_arr = [];
		checkboxes.forEach((checkbox) => {
			checked_arr.push(checkbox.attributes["id"].nodeValue);
		});
		await setCheckBoxes(checked_arr);
	}

	useEffect(() => {
		console.log(checkboxCount);
	}, [checkboxCount]);

	return (
		<>
			<div className="container-fluid" style={{ margin: "8% 0 " }}>
				<div className="row justify-content-around my-0">
					<div
						className={`col-xl-2 col-lg-2 col-md-3 mr-3 ${style.firstPart_J}`}
					>
						<h4>
							Book <span>{3 - checkboxCount}</span> FREE training
							sessions
						</h4>
						<hr className={`${style.below_hd_J}`} />
						<p>Choose any 3 topics from the list</p>
						<br />
						<p className={`${style.bold_firstPart_J}`}>
							Meet our Trainers & Understand our methodology
						</p>
					</div>

					<div
						className={`col-xl-8 col-lg-8 col-md-8 ${style.secondPart_J}`}
					>
						<div className="row justify-content-around justify-items-center">
							<div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 d-flex flex-column align-items-center justify-content-center checkbox-options">
								<div className="text-center mx-auto">
									<h4>SOFT SKILLS</h4>
								</div>
								<div
									className={`btn ${style.white_buttons_J}  p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="resume_writing"
										onChange={checkedBoxes}
									/>
									<label
										htmlFor="resume_writing"
										className="mx-3"
									>
										<p>Art & Science of</p>
										<p>RESUME WRITING</p>
									</label>
									{checkBoxes.includes("resume_writing") && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="impress_interviews"
										onChange={checkedBoxes}
									/>
									<label
										htmlFor="impress_interviews"
										className="mx-3"
									>
										<p>Express to </p>
										<p>Impress Interviews</p>
									</label>
									{checkBoxes.includes(
										"impress_interviews"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="group_discussion"
										onChange={checkedBoxes}
									/>
									<label
										htmlFor="group_discussion"
										className="mx-3"
									>
										<p>Grab the Spotlight</p>
										<p>GROUP DISCUSSION</p>
									</label>
									{checkBoxes.includes(
										"group_discussion"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="harvard_intern"
										onChange={checkedBoxes}
									/>
									<label
										htmlFor="harvard_intern"
										className="mx-3"
									>
										<p>How to Intern at</p>
										<p>Harvard, Stanford, MIT</p>
									</label>
									{checkBoxes.includes("harvard_intern") && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>
							</div>
							<div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 d-flex flex-column align-items-center justify-content-center checkbox-options">
								<div className="text-center mx-auto">
									<h4 className={`${style.secondPart_J} `}>
										COMPUTER SCIENCE
									</h4>
								</div>
								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="cpp_timeComplexity"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="cpp_timeComplexity"
									>
										<p>C/C++ &</p>
										<p>Time Complexity</p>
									</label>
									{checkBoxes.includes(
										"cpp_timeComplexity"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="java_pythonCore"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="java_pythonCore"
									>
										<p>Java, Python</p>
										<p>Core & Advanced</p>
									</label>
									{checkBoxes.includes("java_pythonCore") && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="dataStructures_algo"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="dataStructures_algo"
									>
										<p>Data Structures</p>
										<p> & Algorithms</p>
									</label>
									{checkBoxes.includes(
										"dataStructures_algo"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="github_openSource"
										onChange={checkedBoxes}
									/>
									<label htmlFor="github_openSource">
										<p>GIT HUB, G SOC,</p>
										<p>Open Source Contribution</p>
									</label>
									{checkBoxes.includes(
										"github_openSource"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>
							</div>
							<div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 d-flex flex-column align-items-center justify-content-center checkbox-options">
								<div className="text-center mx-auto">
									<h4 className={`${style.secondPart_J} `}>
										APTITUDE
									</h4>
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="quantitative_ability"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="quantitative_ability"
									>
										<p>Quantitative</p>
										<p>Ability</p>
									</label>
									{checkBoxes.includes(
										"quantitative_ability"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="logical_reasoning"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="logical_reasoning"
									>
										<p>Logical </p>
										<p>Reasoning</p>
									</label>
									{checkBoxes.includes(
										"logical_reasoning"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="verbal_ability"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="verbal_ability"
									>
										<p>Verbal </p>
										<p>Ability</p>
									</label>
									{checkBoxes.includes("verbal_ability") && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>

								<div
									className={`btn ${style.white_buttons_J} p-2 my-4 d-flex justify-content-around`}
								>
									<input
										type="checkbox"
										id="recruiters_linkedin"
										onChange={checkedBoxes}
									/>
									<label
										className="mx-3"
										htmlFor="recruiters_linkedin"
									>
										<p>How to Impress</p>
										<p>Recruiters on LinkedIn</p>
									</label>
									{checkBoxes.includes(
										"recruiters_linkedin"
									) && (
										<div className={`${style.tick_img_J}`}>
											<img src={check} alt="" />
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				{checkboxCount > 0 ? (
					<div className={`${style.btn_div} `}>
						<input
							type="email"
							placeholder="Email ID"
							style={{
								padding: "0.3rem",
								border: "3px solid #000",
							}}
							id="email_addressB2B"
							ref={input_val}
						/>
						<button
							type="button"
							onClick={async (e) => {
								e.preventDefault();
								if (input_val.current.validity.valid) {
									let arr = [];
									checkBoxes.forEach((checkbox) => {
										arr.push(training_sessions[checkbox]);
									});
									let data = {
										email: input_val.current.value,
										trainingSessions: arr,
									};

									console.log("successful");
									await fetch(`${API_ENDPOINT}b2btraining`, {
										method: "POST",
										headers: {
											"Content-Type": "application/json",
										},
										body: JSON.stringify(data),
									})
										.then((res) => res.json())
										.then(async (data) => {
											if (data.success) {
												await setCheckBoxes([]);
												await setCheckboxCount(0);
												let checkboxes =
													document.querySelectorAll(
														".checkbox-options > div > input"
													);
												checkboxes.forEach(
													(checkbox) => {
														checkbox.checked = false;
														checkbox.disabled = false;
													}
												);
											}
										})
										.catch((err) => console.log(err));
								}
							}}
							className={`btn p-2 ${style.black_btn_J} mr-5 mb-5`}
						>
							Book 3 Free training sessions
						</button>
					</div>
				) : (
					<></>
				)}
			</div>
		</>
	);
};
export default B2BTraining;
